<template>
    <div class="custom-control custom-checkbox">
        <input
            class="custom-control-input"
            :class="{'is-invalid': valid === false}"
            type="checkbox"
            :id="identifier"
            :checked="fieldValue == value"
            @change="updateValue($event.target.checked?value : 0)"
            v-bind="$attrs"
            :aria-invalid="!valid"
            :aria-describedby="identifierError"
        >
        <label class="custom-control-label" :for="identifier"><strong>Jahreszahlung ({{ this.settings.tarif.jvl_hoehe }} % Rabatt auf den Jahresabschlag)</strong><br>
            Sichern Sie sich Ihren Rabatt auf den Jahresabschlag und zahlen Sie Ihre Energielieferung jährlich.</label>
<!--        <label class="custom-control-label" :for="identifier" v-else-if="$slots.default"><slot />{{ requiredAsterisk }}</label>-->
        <div :id="identifierError" class="invalid-tooltip" v-html="errorMessages" />

    </div>
</template>
<script>
import FormField from "@/mixins/FormField";

export default {
    name: 'CheckboxInput',
    props: ['value'],
    inject: ['settings'],
    mixins: [FormField],
    inheritAttrs: false,
}
</script>
